// extracted by mini-css-extract-plugin
export default {"dialog":"faGc62k9aPM1UtEZ","subHeader":"QnyhciSwQybKyW4e"};